export const INFORMATION_BOX_TYPE = {
  NEUTRAL: 'neutral',
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
} as const;

export type InformationBoxType = ValueOf<typeof INFORMATION_BOX_TYPE>;
